<ng-template cellTemplate let-dataItem="dataItem">
    <span (click)="$event['ignoreClickOutside'] = true" class="cell-template"
          [ngClass]="cellClassGetter ? cellClassGetter(undefined, dataItem) : {}">
        {{getCellSummary(dataItem)}}
    </span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-multi-select-control #editControl
                              [formControl]="formGroup.get(column.field)" [attr.id]="elementId"
                              [data]="data"
                              [valueField]="'value'"
                              [labelField]="'label'"
                              [readonly]="readonly || cellDisabled(formGroup, dataItem)"
                              [placeholder]="getPlaceholder(dataItem)"
                              (valueChange)="emitValueChange($event, dataItem, formGroup)"
                              [ngClass]="cellClassGetter ? cellClassGetter(formGroup, dataItem) : {}"
                              (focussed)="columnFocusHandler(columnIndex)">
    </wbo-multi-select-control>
</ng-template>
